import { usageIds } from "../constants/usageid.js";
export var RoleSchemaIds;
(function (RoleSchemaIds) {
    RoleSchemaIds["ROLE"] = "role";
})(RoleSchemaIds || (RoleSchemaIds = {}));
export var RoleTags;
(function (RoleTags) {
    RoleTags["SYSTEM"] = "system";
    RoleTags["DOMAIN"] = "domain";
})(RoleTags || (RoleTags = {}));
export const RoleTagsMap = {
    [RoleSchemaIds.ROLE]: [RoleTags.SYSTEM, RoleTags.DOMAIN],
};
export const RoleUsageIds = usageIds(RoleTagsMap);
